import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import styled from 'styled-components';
import { STYLES } from "../styles/Styles";
import { COLOURS } from "../styles/Colours";

interface Props {

}

export const ScrollIndicator = (props: Props) => {

  const progressBarRef = useRef<HTMLDivElement>();

  const handleScroll = () => {
    const el = document.getElementById("scrollingContent");
    const winScroll = el.scrollTop;
    const height = el.scrollHeight - el.clientHeight;
    const scrolled = (winScroll / height) * 100;
    progressBarRef.current.style.width = `${scrolled}%`;
  }

  useLayoutEffect(() => {

    const el = document.getElementById("scrollingContent");
    el.addEventListener('scroll', handleScroll);
    return () => {
      el.removeEventListener('scroll', handleScroll);
    }
  })

  return (
    <ScrollIndicatorContainer>
      <ProgressBar ref={progressBarRef}/>
    </ScrollIndicatorContainer>
  )
}

const ScrollIndicatorContainer = styled.div`
  position: fixed;
  z-index: 1;
  top: 0;
  width: 100vw;
  height: 4px;
`;

const ProgressBar = styled.div`
  height: 100%;
  width: 0;
  background-color: ${COLOURS.blue};
  transition: width 0ms ${STYLES.easeOutQuint};
`;